export const CONTENT_LANGUAGE_CHANGE_ACTION = "CONTENT_LANGUAGE_CHANGE_ACTION";
export const CONTENT_LANGUAGE_CHANGE_SUCCESS = "CONTENT_LANGUAGE_CHANGE_SUCCESS";
export const SETTING_FAIL = "SETTING_FAIL";